module.exports = __webpack_public_path__ + "img/emptyicon.1e893839.svg";